/**
 * PATH: apps/qa/src/pages/records-list/inspectionListFilters.ts
 * FILE_ID: QA-RECORDS-LIST-FILTERS-001
 * PURPOSE: Query params for the QA inspections list filters.
 */

export type InspectionDateMode = 'any' | 'within' | 'before' | 'after'

const JOB_STATUS_KEYS = ['tbc', 'wip', 'done', 'bin'] as const

export function inspectionListParams(input: {
  status?: string
  search?: string
  client?: string
  site?: string
  job?: string
  jobStatusBuckets?: string[]
  dateMode: InspectionDateMode
  withinDays: number
  dateValue: string
  page: number
}): Record<string, string | number> {
  const params: Record<string, string | number> = {
    page: input.page,
    page_size: 20,
  }
  const status = input.status?.trim()
  const search = input.search?.trim()
  const client = input.client?.trim()
  const site = input.site?.trim()
  const job = input.job?.trim()
  if (status) params.status = status
  if (search) params.search = search
  if (client) params.client = client
  if (site) params.site = site
  if (job) params.job = job
  const statusKeys = [...new Set(
    (input.jobStatusBuckets ?? [])
      .map((key) => key.trim().toLowerCase())
      .filter((key) => (JOB_STATUS_KEYS as readonly string[]).includes(key)),
  )]
  if (statusKeys.length > 0 && statusKeys.length < JOB_STATUS_KEYS.length) {
    params.buckets = statusKeys.join(',')
  }
  if (input.dateMode === 'within' && Number.isInteger(input.withinDays) && input.withinDays >= 1) {
    params.created_within_days = input.withinDays
  } else if (input.dateMode === 'before' && input.dateValue) {
    params.created_before = input.dateValue
  } else if (input.dateMode === 'after' && input.dateValue) {
    params.created_after = input.dateValue
  }
  return params
}
